import React from "react";
import { Col, NMPopup, Input } from "@neumetric/blueprint-lib/components";
import { useDispatch, useSelector } from "react-redux";
import {
  auditorActions,
  eduActions,
  getOrganisationsForScheduler,
} from "../../../../store";

export const AllocateBlueprintPopup = ({ visible, modelId, onClose }) => {
  const dispatch = useDispatch();
  const organisationsList = useSelector(getOrganisationsForScheduler) || [];
  const [selectedOrgIds, setSelectedOrgIds] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);

  // fetch orgs when popup is opened
  React.useEffect(() => {
    if (!visible) return;
    dispatch(eduActions.fetchOrganisationsForScheduler());
  }, [visible, dispatch]);


  const handleClose = React.useCallback(() => {
    setSubmitting(false);
    setSelectedOrgIds([]);
    onClose && onClose();
  }, [onClose]);

  const handleAllocate = () => {
    if (!modelId) return;
    setSubmitting(true);
    const action = auditorActions.allocateModelToOrgs({
      model_id: modelId,
      org_id: selectedOrgIds.map((x) => Number(x)).filter(Boolean),
    })
    action.onComplete = handleClose
    action.onFailure = () => {
      setSubmitting(false);
    }
    dispatch(action);
  };

  const orgOptions = organisationsList.map((o) => ({
    id: String(o.id),
    label: o.name,
  }));

  return (
    <NMPopup
      visible={visible}
      width={480}
      title="Allocate Blueprint"
      variant="INFO"
      onModalClose={handleClose}
      actions={[
        {
          btnType: "TEXT",
          variant: "ACTION",
          icon: "CANCEL",
          label: "Cancel",
          disabled: submitting,
          onClick: handleClose,
        },
        {
          btnType: "CONTAINED",
          variant: "ACTION",
          icon: "CHECK_CONFIRM",
          label: "Allocate",
          loading: submitting,
          disabled: submitting || selectedOrgIds.length === 0,
          onClick: handleAllocate,
        },
      ]}
    >
      <Col className="w-100">
        <span className="ff-exo2 text-filled">
          Allocate Blueprint to the organisation chosen below so that Audits can
          be created based on it.
        </span>
        <Input
          typeRepresentation="DROPDOWN"
          layout="vertical"
          searchableFlag
          multiSelection
          options={orgOptions}
          value={selectedOrgIds}
          onChange={(val) => setSelectedOrgIds(val)}
          placeholder="Select organisation(s)"
          popupClassName="allocate-orgs-popup"
          popupMatchSelectWidth={false} // ✅ allow wider dropdown
          dropdownStyle={{ minWidth: 520 }}
          classes={{ root: "w-100 mt-16 mb-0" }}
          hideSelectedOptions={false}
        />
        <div className="w-100 mt-5 text-right">
          <span className="ff-exo2 fs-12 text-filled">
            multiselect possible
          </span>
        </div>
      </Col>
    </NMPopup>
  );
};
